module.exports = __webpack_public_path__ + "static/join_honors_obj03@2x-36711b09a4bd5287083aacf3eb587a32.png";